import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import ChooseImageTopSite from '../../components/Panel/ChooseImageTopSite';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const ChooseImageTopSitePage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/chooseimagetopsite"}>
            Imagem Topo
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Escolher Imagem do 
          <span style={styles.tituloPagina}> Topo do Site </span>
        </h3>

        <ChooseImageTopSite />

      </div>
    </Panel>

  );
};

export default ChooseImageTopSitePage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ChooseImageTopSitePage.js
 **/